module.exports = __webpack_public_path__ + "static/media/miitel-logo-white.3e9b5704.svg";